import PageCollectionHeader from './pageCollectionHeader';

export default PageCollectionHeader;
